// src/main.jsx
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { injectSpeedInsights } from "@vercel/speed-insights";

// 🎨 Estilos globais (ordem recomendada)
import "./styles/theme.css";
import "./styles/app.css";
import "./styles/components.css";
import "./styles/nav.css";
import "./styles/hero.css";
import "./styles/about.css";
import "./styles/services.css";
import "./styles/chat.css";
import "./styles/contact.css";
import "./styles/footer.css";

import App from "./App.jsx";

// 🚀 Inicializa o Speed Insights (apenas em produção)
injectSpeedInsights();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
